import { Clock, Sparkles, ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";

const Leader = () => <span aria-hidden="true" className="mx-3 mb-[0.4em] hidden min-w-[1.5rem] flex-1 border-b border-dotted border-gold/60 sm:block" />;

const Price = ({ prefix, price, onRequest }) => (
  <span className={`shrink-0 whitespace-nowrap font-serif ${onRequest ? "text-lg italic text-ink-soft" : "text-2xl text-gold-deep sm:text-[1.7rem]"}`}>
    {prefix && <span className="mr-1 text-base italic text-ink-soft">{prefix}</span>}
    {price}
  </span>
);

const Chip = ({ icon: Icon, children }) => (
  <span className="inline-flex items-center gap-1.5 rounded-full border border-gold/30 bg-paper px-3 py-1 text-[11px] font-medium uppercase tracking-[0.14em] text-ink-soft">
    <Icon className="h-3.5 w-3.5 text-gold-deep" strokeWidth={1.6} /> {children}
  </span>
);

export const PriceItem = ({ item, onBook, delay = 0 }) => (
  <Reveal delay={delay} className="group border-b border-beige py-7 first:pt-0 last:border-b-0">
    <article data-testid={`price-item-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      {item.variants ? (
        <h3 className="font-serif text-2xl leading-tight text-ink sm:text-[1.7rem]">{item.title}</h3>
      ) : (
        <div className="flex flex-col gap-1 sm:flex-row sm:items-end">
          <h3 className="font-serif text-2xl leading-tight text-ink sm:text-[1.7rem]">{item.title}</h3>
          <Leader />
          <Price prefix={item.prefix} price={item.price} onRequest={item.onRequest} />
        </div>
      )}
      <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-ink-soft">{item.desc}</p>
      {item.variants && (
        <div className="mt-4 space-y-2">
          {item.variants.map((v) => (
            <div key={v.duration} className="flex items-end">
              <span className="inline-flex items-center gap-2 text-[15px] text-ink">
                <Clock className="h-4 w-4 text-gold-deep" strokeWidth={1.6} /> {v.duration}
              </span>
              <span aria-hidden="true" className="mx-3 mb-[0.4em] min-w-[1.5rem] flex-1 border-b border-dotted border-gold/60" />
              <Price price={v.price} />
            </div>
          ))}
        </div>
      )}
      <div className="mt-4 flex flex-wrap items-center gap-2">
        {item.badge && <Chip icon={Sparkles}>{item.badge}</Chip>}
        {item.duration && <Chip icon={Clock}>{item.duration}</Chip>}
        <Chip icon={Sparkles}>Beratung inklusive</Chip>
        <button
          onClick={() => onBook(item.title)}
          data-testid={`price-book-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className="ml-auto inline-flex items-center gap-1.5 pt-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-deep"
        >
          <span className="link-underline">Termin vereinbaren</span>
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </button>
      </div>
    </article>
  </Reveal>
);
